import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentApprovalMedia from "./ContentApprovalMedia";
import { useTranslationApp } from "../../lib/i18next";
import { CONTENT_APPROVAL_MAIN_CREATIVE_LABEL } from "../../i18n/keysTranslations";
import { BOX_SHADOW_FIELDS, INPUT_COLOR_BORDER } from "../../utils/colors";
import { BORDER_RADIUS } from "../../utils/constants";
import { campaignApprovalNoticeAlertSx } from "../../pages/CampaignApproval/utils";
import { CONTENT_APPROVAL_WORKSPACE_BG } from "./contentApprovalLayout";

const ContentApprovalPreview = ({
  currentUrl = "",
  isCarousel = false,
  carouselIndex = 0,
  carouselCount = 0,
  onPrevCarousel = () => {},
  onNextCarousel = () => {},
  draftRevision = 1,
  lockedMessage = "",
  showVersionBadge = true,
  showCardFrame = true,
  mediaWidth = null,
  mediaHeight = null,
}) => {
  const { t } = useTranslationApp();
  const versionLabel = `v${Math.max(1, Number(draftRevision) || 1)}`;

  const mediaSx = {
    borderRadius: 2,
  };

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        bgcolor: CONTENT_APPROVAL_WORKSPACE_BG,
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {lockedMessage ? (
        <Alert
          severity="info"
          sx={{
            ...campaignApprovalNoticeAlertSx,
            mb: 2,
            flexShrink: 0,
          }}
        >
          {lockedMessage}
        </Alert>
      ) : null}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          maxHeight: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {currentUrl ? (
          showCardFrame ? (
            <Box
              sx={{
                position: "relative",
                bgcolor: "background.paper",
                borderRadius: BORDER_RADIUS,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                boxShadow: BOX_SHADOW_FIELDS,
                p: { xs: 1.5, md: 2 },
                maxWidth: "100%",
                maxHeight: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {showVersionBadge ? (
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    left: 12,
                    zIndex: 1,
                    px: 1,
                    py: 0.35,
                    borderRadius: 1,
                    bgcolor: "#111",
                    color: "#fff",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, fontSize: "0.68rem" }}
                  >
                    {versionLabel} · {t(CONTENT_APPROVAL_MAIN_CREATIVE_LABEL)}
                  </Typography>
                </Box>
              ) : null}

              <ContentApprovalMedia
                url={currentUrl}
                mediaWidth={mediaWidth}
                mediaHeight={mediaHeight}
                sx={mediaSx}
              />
            </Box>
          ) : (
            <ContentApprovalMedia
              url={currentUrl}
              mediaWidth={mediaWidth}
              mediaHeight={mediaHeight}
              sx={mediaSx}
            />
          )
        ) : null}

        {isCarousel && carouselCount > 1 ? (
          <>
            <IconButton
              onClick={onPrevCarousel}
              disabled={carouselIndex === 0}
              sx={{
                position: "absolute",
                left: { xs: 4, md: 16 },
                bgcolor: "background.paper",
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                boxShadow: BOX_SHADOW_FIELDS,
                "&:hover": {
                  bgcolor: "background.paper",
                },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>
            <IconButton
              onClick={onNextCarousel}
              disabled={carouselIndex >= carouselCount - 1}
              sx={{
                position: "absolute",
                right: { xs: 4, md: 16 },
                bgcolor: "background.paper",
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                boxShadow: BOX_SHADOW_FIELDS,
                "&:hover": {
                  bgcolor: "background.paper",
                },
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default ContentApprovalPreview;
